import { AlertCircle, Megaphone, Activity, TrendingUp, Users, ArrowUpRight, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const ChallengeOpportunity = () => {
  return (
    <section className="py-10 md:py-14 bg-muted/30">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto space-y-8">
          {/* The Challenge */}
          <div className="bg-primary text-white rounded-3xl p-8 md:p-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-8">The Challenge</h2>
            <div className="space-y-6">
              <div className="flex gap-4 items-start">
                <div className="bg-white/20 rounded-full p-3 flex-shrink-0">
                  <AlertCircle className="h-6 w-6" />
                </div>
                <p className="text-lg md:text-xl">Missed opportunities from referrals that never materialize</p>
              </div>
              <div className="flex gap-4 items-start">
                <div className="bg-white/20 rounded-full p-3 flex-shrink-0">
                  <Megaphone className="h-6 w-6" />
                </div>
                <p className="text-lg md:text-xl">Under-optimized marketing from your #1 source of new clients</p>
              </div>
              <div className="flex gap-4 items-start">
                <div className="bg-white/20 rounded-full p-3 flex-shrink-0">
                  <Activity className="h-6 w-6" />
                </div>
                <p className="text-lg md:text-xl">Operational inefficiencies that limit sustainable growth</p>
              </div>
            </div>
          </div>

          {/* The Opportunity */}
          <div className="bg-primary text-white rounded-3xl p-8 md:p-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-8">The Opportunity</h2>
            <div className="space-y-6">
              <div className="flex gap-4 items-start">
                <div className="bg-white/20 rounded-full p-3 flex-shrink-0">
                  <TrendingUp className="h-6 w-6" />
                </div>
                <p className="text-lg md:text-xl">300% average ROI growth through systematic optimization</p>
              </div>
              <div className="flex gap-4 items-start">
                <div className="bg-white/20 rounded-full p-3 flex-shrink-0">
                  <Users className="h-6 w-6" />
                </div>
                <p className="text-lg md:text-xl">Systematically replicate your ideal client relationships</p>
              </div>
              <div className="flex gap-4 items-start">
                <div className="bg-white/20 rounded-full p-3 flex-shrink-0">
                  <ArrowUpRight className="h-6 w-6" />
                </div>
                <p className="text-lg md:text-xl">A more predictable growth trajectory within your business</p>
              </div>
            </div>
          </div>

          {/* Implementation Sections */}
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-primary text-white rounded-3xl p-8">
              <div className="bg-white/20 rounded-full p-4 w-16 h-16 flex items-center justify-center mb-6">
                <Activity className="h-8 w-8" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4">Rapid Implementation</h3>
              <p className="text-lg text-white/90">
                Our streamlined approach delivers real results. See measurable growth in your first month, 
                with compounding benefits over 12 months.
              </p>
            </div>
            
            <div className="bg-primary text-white rounded-3xl p-8">
              <div className="bg-white/20 rounded-full p-4 w-16 h-16 flex items-center justify-center mb-6">
                <Users className="h-8 w-8" />
              </div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4">Effortless Execution</h3>
              <p className="text-lg text-white/90">
                Our proven templates and tools, combined with personalized coaching, make implementation 
                simple and straightforward.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center pt-8">
            <Button 
              size="lg"
              className="bg-secondary hover:bg-secondary/90 text-white font-semibold px-8 py-6 text-lg"
              asChild
            >
              <a href="/book-call">
                Start Capturing More Clients <ArrowRight className="ml-2 h-5 w-5" />
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChallengeOpportunity;
